import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import Spinner from '@components/spinner'
import '../Sidebar.sass'

class ParentAccount extends Component {
  static propTypes = {
    id: PropTypes.number,
    parentAccountStore: PropTypes.object,
    sidebarStore: PropTypes.object,
    staticData: PropTypes.object
  }

  constructor (props) {
    super(props)
    const { parentAccountStore, id } = this.props
    parentAccountStore.load(id)
  }

  handleAccountNameClick = () => {
    const { sidebarStore } = this.props
    sidebarStore.closeSidebar()
  }

  render () {
    const { parentAccountStore, sidebarStore, staticData } = this.props
    const { parentAccount, loading } = parentAccountStore
    const { ACCOUNT_TYPES } = staticData.CONST

    if (loading) return <Spinner />
    if (!parentAccount) return null

    return (
      <div>
        <h1
          className='sidebar-wrapper__content__link'
          onClick={() => this.handleAccountNameClick}
        >
          <NavLink to={`/parent-account/${parentAccount.id}`}>
            {parentAccount.parentAccountName}
          </NavLink>
          <p>{parentAccount.parentAccountCode}</p>
        </h1>
        <h2>Parent account information</h2>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Account type
          </span>
          <p>{parentAccountStore.accountType}</p>
        </div>
        {parentAccount.accountTypeId === ACCOUNT_TYPES.HEDGE_FUND && (
          <div className='group'>
            <span className='sidebar-wrapper__content__label--default'>
              HF compliance required
            </span>
            <p>{parentAccount.hedgeFundRequired ? 'Yes' : 'No'}</p>
          </div>
        )}
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Invoicing coverage
          </span>
          <p>{parentAccountStore.invoicingCoverage}</p>
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Invoicing entity
          </span>
          {parentAccountStore.globalInvoicingEntity ? (
            <a
              className='sidebar-wrapper__content__link clickable'
              onClick={() =>
                sidebarStore.openSidebar({
                  id: parentAccountStore.globalInvoicingEntity.id,
                  template: 'invoicing-entity'
                })
              }
            >
              <p>{parentAccountStore.globalInvoicingEntity.legalName}</p>
            </a>
          ) : (
            <p>-</p>
          )}
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Case code
          </span>
          <p>{parentAccountStore.requiredCode}</p>
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            External Compliance Verification
          </span>
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Show submitted Expert Names on Client Interface
          </span>
          <p>{parentAccountStore.expertsDisclosed}</p>
        </div>

        <h2>Operational guidelines</h2>
        <div className='group'>
          <p
            className='sidebar-wrapper__rich-text rich-text--dark'
            dangerouslySetInnerHTML={{
              __html: parentAccount.operationalGuidelines || '-'
            }}
          />
        </div>
      </div>
    )
  }
}

export default inject('sidebarStore', 'parentAccountStore', 'staticData')(
  observer(ParentAccount)
)
